import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ReactiveFormsModule, FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BackOfficeSession } from 'src/app/Services/Api.BackOfficeSession/BackOfficeSession';
import { environment } from "src/environments/environment";
import { OpenModal } from '../../../OpenModal';
import { TypeDialog, ButtonsDialog } from '../../../model-type';
import { LoginItem } from 'src/app/Models/Login/Login';
import { HomeComponent } from '../../Inicio/Home/home.component';

@Component({
  selector: 'app-login',
  templateUrl: '../Login/login.component.html',
  styleUrls: ['../Login/login.component.css']
})

export class LoginComponent {

  public form: FormGroup;
  submitted = false;
  env = environment;
  public password: string;

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  // tslint:disable-next-line: variable-name
  constructor(private router: Router, private fb: FormBuilder, private _authenticationService: BackOfficeSession,
    private OModal: OpenModal) {
    this.form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required],
      recaptchaReactive: [null, Validators.required]
    });
  }

  ngOnInit = () => {
    this.buildForm();
  }

  private buildForm() {
    this.form = this.fb.group({});
  }

  onSubmit = () => {
    this.submitted = true;

    if (this.form.valid) {

      this._authenticationService.login(this.form.get('email').value, this.form.get('password').value).subscribe(res => {
        const token = (res as any).token;

        if (token == null) {
          const error = (res as any).error.description;

          this.OModal.openDialog(TypeDialog.information, 'Advertencia', error, ButtonsDialog.ok, 300);
        } else {
          sessionStorage.setItem('token', token);
          const record = (res as any).record;
          sessionStorage.setItem('usuarioID', record.usuarioID);
          sessionStorage.setItem('comercioID', record.comercio);

          //sessionStorage.setItem('perfilID', record.perfilID);

          sessionStorage.setItem('Nombre', record.nombre);
          //sessionStorage.setItem('Apellido', record.apellido);

          // this.Home.obtenerMenu();
          this.router.navigate(['/home']);
        }
      },
        err => {
          if (err.status === 404) {
            this.OModal.openDialog(TypeDialog.warn, 'Error',
              'Usuario y/o Password Incorrecto', ButtonsDialog.ok, 300);
          }
        });

    } else {
      this.OModal.openDialog(TypeDialog.warn, 'Error',
      'Correo incorrecto o datos incompletos.', ButtonsDialog.ok, 300);
    }

  }

  get f() {
    return this.form.controls;
  }

  resetValue = () => {
    this.router.navigate(['/recuperar']);
  }

  setKindPerson = () => {
  }

  onInputChange(event: any) {
    const initalValue = event.target.value;

    event.target.value = event.target.value.replace(/ /g, '');
    if (initalValue !== event.target.value) {
      event.stopPropagation();
    }
  }
}
